import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { ChoiceStyles, applyChoiceCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-choice-group',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxChoiceStyleDirective {
  componentStyle = input<{
    style: ChoiceStyles
    choiceType: 'radio' | 'checkbox'
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyChoiceCustomStyles(
        this.componentStyle().style,
        theme(),
        this.componentStyle().choiceType
      )
      this.styleClassName.set(className)
    })
  }
}
